import React from 'react';
import { useQuery } from '@tanstack/react-query';

const CachedImage = ({ src, alt, style, onError }) => {
    const { data: imageBase64 } = useQuery({
        queryKey: ['colorbar', src],
        queryFn: async () => {
            const res = await fetch(src);
            if (!res.ok) throw new Error('Failed to load image');
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        enabled: !!src,
        staleTime: Infinity,
        cacheTime: 1000 * 60 * 60, // 1 hour
        refetchOnWindowFocus: false,
    });

    if (!imageBase64) return null;

    return <img src={imageBase64} alt={alt} style={style} onError={onError} />;
};

export default CachedImage;
